import { render, staticRenderFns } from "./with-sidebar.vue?vue&type=template&id=b7288a40&"
import script from "./with-sidebar.vue?vue&type=script&lang=js&"
export * from "./with-sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports